<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <InfoCard :infoData="this.infoDetails" :loading="this.loading" />
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Users</h5>
                <div class="flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-info"
                    @click="expSetNow()"
                    fdprocessedid="1yahzs"
                  >
                    <i class="ri-download-line align-bottom me-1"></i> Export
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3 align-items-center">
                  <div class="col-xxl-5 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        v-model="search_key"
                        @keydown.enter.prevent
                        @input="fetchList(1)"
                        placeholder="Enter Your Phone Number "
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                    
                  </div>

                  <div
                    class="col-xxl-2 col-sm-4"
                    v-if="ldata != null && ldata.role == 'superadmin'"
                  >
                    <select
                      class="form-control"
                      v-model="search_sortby"
                      @change="fetchList(1)"
                      name="sort-options"
                      id="sortOptions"
                    >
                      <option value="" selected>Sort By</option>
                      <option
                        v-for="(option, index) in sortOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.label }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
            <div class="card-body pt-0">
              <div class="mt-5">
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="loading">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      title="user"
                      :ldata="ldata"
                      :headers="headers"
                      :tableData="formattedUsers"
                      @edit="viewCustomer"
                      @delete="openDeleteDialog"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!loading">
                  <div class="me-3">
                    <select
                      class="form-select w-auto"
                      v-model="limitProxy"
                      @change="fetchList(1)"
                    >
                      <template
                        v-for="(role, index) in paginationOptions"
                        :key="index"
                      >
                        <option :value="role">{{ role }}</option>
                      </template>
                    </select>
                  </div>
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="fetchList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="users.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="users.length >= limit"
                          class="page"
                          href="javascript:void(0)"
                          @click="fetchList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="users.length >= limit"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="fetchList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ToastNotification ref="toast" />
    <LoaderLoading v-if="overallLoading" />

    <DeleteDialog
      ref="deleteDialog"
      title="Delete Customer ?"
      @confirm="deleteCustomer"
    />
  </div>
</template>

<script>
import {
  getCustomer,
  getCustomerById,
  deleteCustomerById,
} from "@/apis/customer";
import listMixin from "@/mixins/listMixin";
import { customerHeaders } from "@/constants/headers";
import { customersInfoDetails } from "@/constants/infodetails";
import { customerSortOptions } from "@/constants/sort";

export default {
  name: "customersList",

  mixins: [listMixin],

  data() {
    return {
      users: [],

      search_key: "",
      search_sortby: "",

      headers: customerHeaders,
      infoDetails: customersInfoDetails,
      sortOptions: customerSortOptions,
    };
  },
  methods: {
    async expSetNow() {
      const fields = [
        "name",
        "created_at",
        "email",
        "mobile",
        "booking",
        "revenue",
        "cancelletaion",
        "wallet",
      ];
      this.$exportCsv(this.formattedUsers, "Customer.csv", fields);
    },

    async fetchList(pageNo) {
      const response = await this.fetch(pageNo, getCustomer, {
        phone_number: this.search_key,
        sort_by: this.search_sortby,
        ascending: this.search_sortby === "newest" ? false : true,
      });

      this.users = response.data;

      this.infoDetails[0].count = response?.total_entries;
      this.infoDetails[1].count = response?.stats?.newUserIn30Days;
      this.infoDetails[2].count = response?.stats?.activeUsersCount;

      this.stopLoading();
    },

    async viewCustomer(customer) {
      await this.update(
        getCustomerById,
        customer.spec_id,
        "/user",
        "phone_number"
      );
    },

    async deleteCustomer(customer) {
      await this.delete(deleteCustomerById, customer.spec_id);
    },
  },

  computed: {
    formattedUsers() {
      return this.users.map((user) => ({
        id: user.id,
        spec_id: user.customer_id,
        name: user.name || "N/A",
        created_at: user.created_at
          ? new Date(user.created_at).toLocaleString()
          : "N/A",
        mobile: user.phone_number || "N/A",
        email: user.email || "N/A",
        booking: user.bookingCount,
        revenue: user.total_revenue || "0",
        cancelletaion: user.cancelledBooking || "0",
        wallet: user.wallet_balance || "0",
        status: user.is_active ? "Active" : "In Active",
      }));
    },
  },
};
</script>
